import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'minutesToHours'
  })
  export class MinutesToHours implements PipeTransform {
    transform(value: number): string {
       if(value > 0 && (value <= 120)) {
         return value + ' min';
  
       } else {
        let seconds = value * 60;

        // // calculate (and subtract) whole days
        // let days = Math.floor(seconds / 86400);
        // seconds -= days * 86400;

        // calculate (and subtract) whole hours
        let hours = Math.floor(seconds / 3600);
        seconds -= hours * 3600;

        // calculate (and subtract) whole minutes
        let minutes = Math.floor(seconds / 60) % 60;

        return hours + ' h ' + (minutes ? minutes + ' min': '');
       }
    }
  }